<template>
  <div
    class="color-container"
    :class="{ selected: isSelected, 'not-cursor-pointer': isSingleMode }"
    @click="emitOpenPicker"
  >
    <ColorCircle :color="color.color || color" />

    <div class="color-description" v-if="!hideLabels">
      <p class="color-name">
        {{ colorName }}
      </p>
      <p class="color-title">{{ color.label || "color" }}</p>
    </div>
  </div>
</template>

<script>
import ColorCircle from "@/components/Projects/Project/Colors/ColorCircle.vue";

export default {
  name: "ColorPickerColorToChange",
  components: { ColorCircle },
  props: {
    color: {
      type: Object,
    },
    isSingleMode: {
      type: Boolean,
    },
    openedPicker: {
      type: String,
    },
    hideLabels: {
      type: Boolean,
    },
    componentKey: {
      type: String,
    },
  },
  computed: {
    colorName() {
      return this.color && this.color?.color
        ? this.color.color?.family_name?.toLowerCase()
        : this.color?.family_name?.toLowerCase() || "none";
    },

    isSelected() {
      return (
        this.openedPicker &&
        this.openedPicker ===
          this.color.key?.trim()?.toLowerCase()?.replace(/\s+/g, "_")
      );
    },
  },

  methods: {
    emitOpenPicker() {
      this.$emit("openPicker", this.color.key);
    },
  },
};
</script>

<style lang="scss" scoped>
.color-container {
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  border-radius: 6px;
  // padding: 0.25rem;
  transition: all 0.2s;

  &:hover {
    .color-name {
      text-decoration: underline;
    }
  }
  &.selected {
    .color-name {
      text-decoration: underline;
    }
  }

  &.not-cursor-pointer {
    cursor: initial;
    border: none;
  }

  ::v-deep .color-circle {
    margin-right: 1rem;
  }
  .color-title {
    font-size: 0.85rem;
    color: $placeholder;
    margin-bottom: 0.2rem;
    text-transform: capitalize;
  }
  .color-name {
    font-size: 1rem;
    font-weight: bold;
    text-transform: uppercase;
  }
}
</style>
